import { useEffect, useState } from 'react';

import { ApiErrors, GqlRequestOptions } from '@common/api-request';

import { isLoggedIn } from './graphql/authentication.2';

export type AuthState = 'authenticated' | 'pending' | 'failed';
export const useAuthenticationState = () => {
  const [authState, setAuthState] = useState<AuthState>('pending');

  useEffect(() => {
    const checkLoggedIn = async () => {
      try {
        const authState = await getAuthState();
        setAuthState(authState);
      } catch (e) {
        // noop
      }
    };
    checkLoggedIn();
  }, []);

  return { authState };
};

export const getAuthState = async ({
  ignore_error = ApiErrors.NOT_LOGGED_IN,
  ...params
}: GqlRequestOptions = {}): Promise<AuthState> => {
  const { data } = await isLoggedIn(null, { ignore_error, ...params });
  return data?.isLoggedIn ? 'authenticated' : 'failed';
};
